var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1974_3878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0878 14.48C14.0878 14.68 14.0078 14.872 13.8638 15.016C13.7198 15.16 13.5278 15.24 13.3278 15.24H2.66381C2.46381 15.24 2.26381 15.16 2.12781 15.016C1.98381 14.872 1.90381 14.68 1.90381 14.48V0.76C1.90381 0.56 1.98381 0.36 2.12781 0.224C2.26381 0.08 2.46381 0 2.66381 0H9.20781C9.40781 0 9.60781 0.08 9.75181 0.224L13.8718 4.344C14.0158 4.488 14.0958 4.68 14.0958 4.888V14.48H14.0878Z",
    fill: "#EBECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0878 14.48V15.24C14.0878 15.44 14.0078 15.64 13.8638 15.776C13.7198 15.92 13.5278 16 13.3278 16H2.66381C2.23981 16 1.90381 15.656 1.90381 15.24V14.48C1.90381 14.68 1.98381 14.872 2.12781 15.016C2.27181 15.16 2.46381 15.24 2.66381 15.24H13.3278C13.7518 15.24 14.0878 14.896 14.0878 14.48Z",
    fill: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.375977 8.38379H15.616V12.1918C15.616 12.6158 15.272 12.9518 14.856 12.9518H1.14398C0.943977 12.9518 0.743977 12.8718 0.607977 12.7278C0.463977 12.5838 0.383977 12.3918 0.383977 12.1838V8.38379H0.375977Z",
    fill: "#0092D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90398 8.38396V6.85596L0.375977 8.38396H1.90398ZM14.088 8.38396L14.104 6.85596L15.624 8.38396H14.088Z",
    fill: "#007199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.088 4.888V4.992H9.96801C9.54401 4.992 9.20801 4.648 9.20801 4.232V0C9.40801 0 9.60801 0.08 9.75201 0.224L13.88 4.344C14.016 4.488 14.096 4.68 14.088 4.888Z",
    fill: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34387 12.0238H3.46387V9.07178H4.63987L5.16787 10.9198L5.67987 9.07178H6.85587V12.0238H5.98387V11.1198L5.99987 10.6558L6.04787 10.1278H6.03187L5.50387 12.0238H4.83187L4.28787 10.1278L4.31987 10.5598L4.35187 11.0238V12.0238H4.34387ZM8.29587 12.0238H7.33587V9.07178H8.75187C9.57587 9.07978 9.99987 9.41578 10.0239 10.0638C10.0159 10.7518 9.59987 11.0958 8.78387 11.1038H8.30387V12.0238H8.29587ZM8.29587 10.4158H8.69587C8.95187 10.4158 9.07987 10.2958 9.07987 10.0638C9.07987 9.86378 8.91187 9.75978 8.56787 9.75978H8.29587V10.4158ZM10.1439 11.4078V10.7358L11.5119 9.12778H12.2959V10.7838H12.6639V11.4078H12.2959V12.0158H11.4959V11.4078H10.1439ZM11.4959 9.90378L10.8079 10.7838H11.4959V9.90378Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1974_3878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.8ea11201ae4363afe08428fad69bab6e.svg";
export { ForwardRef as ReactComponent };